const CLIENT_SESSION_MARKER_KEY = "qw_gx_r7"

export function hasClientSessionMarker() {
	try {
		return window.localStorage.getItem(CLIENT_SESSION_MARKER_KEY) === "1"
	} catch (error) {
		return false
	}
}

export function setClientSessionMarker() {
	try {
		window.localStorage.setItem(CLIENT_SESSION_MARKER_KEY, "1")
	} catch (error) {
		// Ignore storage failures. This marker only controls optional eager auth restore.
	}
}

export function clearClientSessionMarker() {
	try {
		window.localStorage.removeItem(CLIENT_SESSION_MARKER_KEY)
	} catch (error) {
		// Ignore storage failures.
	}
}
